import React from 'react';
import { Routes, Route, useLocation } from "react-router-dom"
import CreateCampaigns from './containers/CreateCampaigns';
import NavBar from './components/NavBar';
import ViewCampaigns from './containers/ViewCampaigns';
import ViewSegments from './containers/ViewSegments';
import CampaignDetails from './containers/CampaignDetails';
import "./App.scss"
import { events, routes } from './utils/constants';
import CreateSegments from './containers/CreateSegments';
import { sendEvents } from './utils/events';

function App() {
  let location = useLocation();

  React.useEffect(() => {
    sendEvents(events.PAGE_VIEW);
  }, [location]);

  return (
    <NavBar>
      <Routes>
        <Route path={routes.viewCampaigns} element={<ViewCampaigns />} />
        <Route path={`${routes.viewCampaigns}:campaignId`} element={<CampaignDetails />} />
        <Route path={`${routes.campaignSummary}/:campaignId`} element={<CampaignDetails />} />
        <Route path={routes.createCampaign} element={<CreateCampaigns />} />
        <Route path={routes.viewSegments} element={<ViewSegments />} />
        <Route path={routes.createSegments} element={<CreateSegments />} />
      </Routes>
    </NavBar>
  );
}

export default App;
